<div class="main-container" style="margin: auto">
    <div class="row page-header-actions">
        <button mat-icon-button [routerLink]="['/flujo-credito-light']" matTooltip="Volver a Flujo de Crédito Light">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="page-content">
        <h1 class="mat-section-title">Flujo de Crédito Light</h1>
        <label class="mat-sub-title mb-5" for="">Flujo de aprobación</label>

        <mat-stepper [linear]="true" #stepper>
            <mat-step label="Ficha cliente">
                <div class="row justify-content-end mt-3 mb-2">
                    <button mat-flat-button color="primary" (click)="generatePDF()" [disabled]="isPDFLoading">
                        <mat-icon class="scale-150">download</mat-icon>
                        Descargar PDF
                        <mat-icon *ngIf="isPDFLoading" iconPositionEnd>
                            <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                        </mat-icon>
                    </button>
                </div>
                <ng-container *ngIf="validaClave('modelo01')">
                    <app-plantilla-salfa-fc-light [idTransaccion]="currentIdTransaccion" [generalReport]="generalReport"></app-plantilla-salfa-fc-light>
                </ng-container>
                <app-files-manager
                    [files]="attachedFiles"
                    [isFileUploading]="isFileUploading"
                    (uploadFileEvent)="uploadFile($event)"
                    (deleteFileEvent)="deleteFile($event)">
                </app-files-manager>

                <div class="d-flex justify-content-end mt-4">
                    <button mat-raised-button color="primary" matStepperNext class="ml-3" (click)="createNewStage(flujoCreditoLightStages.EN_APROBACION)">
                        Continuar
                        <mat-icon iconPositionEnd class="scale-150">arrow_forward</mat-icon>
                    </button>
                </div>
            </mat-step>
            <mat-step label="En aprobación">
                <div class="d-flex flex-column align-items-center">

                    <div class="row p-0 mt-2 mb-5 d-flex justify-content-between w-100">

                        <ng-container *ngFor="let step of approvalFlow?.approvalFlowResponse?.definicionAprobaciones?.flujoAprobaciones; let isLast = last">

                            <div class="col-12 col-lg-2 p-0">
                                <mat-card
                                    class="w-100"
                                    [ngClass]="{
                                        'primary-background-color': selectedStep === step.id,
                                        'clickable': getStatus(step) !== stepStatus.DISABLED && getStatus(step) !== stepStatus.PENDING,
                                        'no-clickable': getStatus(step) === stepStatus.DISABLED || getStatus(step) === stepStatus.PENDING,
                                    }"
                                    (click)="setSelectedStep(step)"
                                    >
                                    <mat-card-header>
                                        <div
                                            mat-card-avatar
                                            class="custom-avatar"
                                            [ngClass]="{
                                                'avatar-disabled': getStatus(step) === stepStatus.DISABLED,
                                                'avatar-pending': getStatus(step) === stepStatus.PENDING,
                                                'avatar-completed': getStatus(step) === stepStatus.COMPLETED,
                                                'avatar-denied': getStatus(step) === stepStatus.DENIED
                                            }"
                                            >
                                            <span *ngIf="getStatus(step) === stepStatus.CURRENT || getStatus(step) === stepStatus.PENDING || getStatus(step) === stepStatus.DISABLED">{{ step.id }}</span>
                                            <mat-icon *ngIf="getStatus(step) === stepStatus.COMPLETED">check</mat-icon>
                                            <mat-icon *ngIf="getStatus(step) === stepStatus.DENIED">close</mat-icon>
                                        </div>
                                        <mat-card-title class="font-weight-500">{{ step.nombre }}</mat-card-title>
                                        <mat-card-subtitle>Aprobadores</mat-card-subtitle>
                                        <mat-card-subtitle class="pb-4">usuarios/grupos</mat-card-subtitle>
                                    </mat-card-header>
                                </mat-card>
                            </div>
                            <div *ngIf="!isLast" class="col-12 col-lg-1 d-flex justify-content-center align-items-center px-0">
                                <mat-icon class="arrow d-none d-lg-block">east</mat-icon>
                                <mat-icon class="arrow d-block d-lg-none my-3">south</mat-icon>
                            </div>
                        </ng-container>
                    </div>

                    <mat-card class="container-xl mb-5">
                        <mat-card-content>
                            <div class="row">
                                <div class="col-12 mb-4 text-center">
                                    <h2>{{ getRequestStatus() }}</h2>
                                    <p class="text-muted">Etapa actual: {{ currentStep }}</p>
                                </div>
                                <div *ngIf="previousApprovalFlowItem" class="col-12">
                                    <p class="font-weight-500 mb-4">Total montos aprobados: {{ lastTotalApprovedAmount | number:'1.0-0' }}</p>
                                    <div class="d-flex justify-content-between mb-5">
                                        <ng-container *ngIf="!isFlowCompleted()">
                                            <div *ngFor="let amount of previousApprovalFlowItem.valores.montos">
                                                <mat-chip class="primary-background-color">
                                                    <span class="font-weight-500">{{ amount.displayName || amount.nombre }}: {{ amount.valor | number:'1.0-0' }}</span>
                                                </mat-chip>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="isFlowCompleted() && currentApprovalFlowItem">
                                            <div *ngFor="let amount of currentApprovalFlowItem.valores.montos">
                                                <mat-chip class="primary-background-color">
                                                    <span class="font-weight-500">{{ amount.displayName || amount.nombre }}: {{ amount.valor | number:'1.0-0' }}</span>
                                                </mat-chip>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <mat-divider class="mb-5"></mat-divider>
                                </div>
                                <div class="col-12 mb-5">
                                    <p><span class="font-weight-500">Tipo decisión:</span> Manual</p>
                                    <p><span class="font-weight-500">Última actualización: </span>
                                        {{
                                            previousApprovalFlowItem?.fechaActualizacion
                                            ? (previousApprovalFlowItem?.fechaActualizacion | date: 'dd/MM/yyyy') 
                                            : 'Sin información'
                                        }}
                                    </p>
                                    <mat-divider></mat-divider>
                                </div>
                                <div class="col-12 mb-5">
                                    <h3 class="mb-5">Campos Motor Decisional</h3>
                                    <ng-container *ngIf="ruleEngineFieldsWithValue.length > 0; else showSpinner">
                                        <div class="row">
                                            <div *ngFor="let field of ruleEngineFieldsWithValue" class="col-6 row align-items-center 2 mx-0">
                                                <div class="col-4 mb-4">
                                                    <label class="data-label">{{ field.displayName }}:</label>
                                                </div>
                                                <div class="col-8 mb-4 pr-0">
                                                    <div class="data-item rounded-pill pl-3">
                                                        <span *ngIf="field.type === FIELD_TYPES.STRING">{{ field.value }}</span>
                                                        <span *ngIf="field.type === FIELD_TYPES.NUMBER">{{ (+field.value) | number:'1.0-0' }}</span>
                                                        <span *ngIf="field.type === FIELD_TYPES.BOOLEAN">{{ field.value ? 'Si' : 'No' }}</span>
                                                        <span *ngIf="field.type !== FIELD_TYPES.STRING && field.type !== FIELD_TYPES.NUMBER && field.type !== FIELD_TYPES.BOOLEAN">{{ field.value }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-template #showSpinner>
                                        <div class="row justify-content-center">
                                            <mat-spinner></mat-spinner>
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="col-12 mb-5 d-flex justify-content-end">
                                    <button mat-stroked-button color="primary" class="font-weight-500"
                                        (click)="verFichaCliente()">
                                        <mat-icon class="scale-150 mr-2">person</mat-icon>
                                        Ver ficha cliente
                                    </button>
                                    <button mat-flat-button color="primary" class="font-weight-500 ml-3"
                                        (click)="showDetailsStep2 = !showDetailsStep2">
                                        <mat-icon class="scale-150" *ngIf="!showDetailsStep2">visibility</mat-icon>
                                        <mat-icon class="scale-150" *ngIf="showDetailsStep2">visibility_off</mat-icon>
                                        {{ getDetailsButtonText() }}
                                    </button>
                                </div>
                                <div *ngIf="isAdmin && isApproverUser && showDetailsStep2 && isCurrentStep() && !isFlowCompleted()" class="col-12" [formGroup]="montosForm">
                                    <mat-divider class="mb-5"></mat-divider>

                                    <div class="mat-table-container mb-4">
                                        <table mat-table [dataSource]="camposDataSource">
                                            <ng-container matColumnDef="producto">
                                                <th mat-header-cell *matHeaderCellDef>Producto</th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element.producto }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>Total</td>
                                            </ng-container>

                                            <ng-container matColumnDef="montoResuelto">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Monto resuelto
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="vertical-align: middle">
                                                    <mat-form-field appearance="outline" class="w-100 mt-4">
                                                        <mat-label>Monto</mat-label>
                                                        <input
                                                            matInput
                                                            formControlName="{{ element.formControlName }}"
                                                            type="{{ element.inputType }}"
                                                            required/>
                                                        <mat-error *ngIf="montosForm.get(element.formControlName)?.hasError('required')">
                                                            Este campo es obligatorio
                                                        </mat-error>
                                                    </mat-form-field>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>{{ currentTotalApprovedAmount | number:'1.0-0' }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="camposColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: camposColumns"></tr>
                                            <tr mat-footer-row *matFooterRowDef="camposColumns"></tr>
                                        </table>
                                    </div>

                                    <div *ngIf="selectedApprovalFlowItem && selectedApprovalFlowItem.valores.otros && selectedApprovalFlowItem.valores.otros.length > 0">
                                        <h3 class="mb-3">Otros campos</h3>

                                        <form [formGroup]="otrosForm">
                                            <div *ngFor="let other of selectedApprovalFlowItem.valores.otros">

                                                <mat-form-field *ngIf="other.valores && other.valores.length > 0" appearance="outline" class="w-100">
                                                    <mat-label>{{ other.displayName || other.nombre }}</mat-label>
                                                    <mat-select [formControlName]="other.nombre" required>
                                                        <mat-option *ngFor="let value of other.valores" [value]="value.key">
                                                            {{ value.value }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="otrosForm.get(other.nombre)?.hasError('required')" class="pb-5">
                                                        Este campo es obligatorio
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field *ngIf="getInputType(other.tipo || '') !== 'date' && (!other.valores || other.valores.length === 0)" appearance="outline" class="w-100">
                                                    <mat-label>{{ other.displayName || other.nombre }}</mat-label>
                                                    <input matInput [formControlName]="other.nombre" type="{{ getInputType(other.tipo || '') }}" required/>
                                                    <mat-error *ngIf="otrosForm.get(other.nombre)?.hasError('required')" class="pb-5">
                                                        Este campo es obligatorio
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field *ngIf="getInputType(other.tipo || '') === 'date'" appearance="outline" class="w-100">
                                                    <mat-label>{{ other.displayName || other.nombre }}</mat-label>
                                                    <input matInput [matDatepicker]="picker" [formControlName]="other.nombre"/>
                                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                    <mat-error *ngIf="otrosForm.get(other.nombre)?.hasError('required')" class="pb-5">
                                                        Debe seleccionar una fecha
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </form>
                                    </div>

                                    <h3 class="mb-3">Comentarios</h3>

                                    <form [formGroup]="commentsForm">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Comentarios</mat-label>
                                            <textarea matInput formControlName="comments"></textarea>
                                            <mat-error *ngIf="commentsForm.get('comments')?.hasError('required')" class="pb-5">
                                                Este campo es obligatorio
                                            </mat-error>
                                        </mat-form-field>
                                    </form>

                                    <div *ngIf="isAdmin && isApproverUser" class="d-flex justify-content-end mt-4">
                                        <button mat-flat-button color="warn" (click)="updateApprovalFlow(false)" class="font-weight-500" [disabled]="isRejectLoading || isApproveLoading">
                                            Rechazar
                                            <mat-icon *ngIf="isRejectLoading" iconPositionEnd>
                                                <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                                            </mat-icon>
                                        </button>

                                        <button mat-flat-button color="primary" (click)="updateApprovalFlow(true)" class="font-weight-500 ml-3" [disabled]="isApproveLoading || isRejectLoading">
                                            Aprobar
                                            <mat-icon *ngIf="isApproveLoading" iconPositionEnd>
                                                <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                                            </mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <div *ngIf="showDetailsStep2 && (!isCurrentStep() || isFlowCompleted() || !isAdmin || !isApproverUser)" class="col-12" [formGroup]="montosForm">
                                    <mat-divider class="mb-5"></mat-divider>

                                    <div class="mat-table-container mb-4">
                                        <table mat-table [dataSource]="camposDataSource">
                                            <ng-container matColumnDef="producto">
                                                <th mat-header-cell *matHeaderCellDef>Producto</th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element.producto }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>Total</td>
                                            </ng-container>

                                            <ng-container matColumnDef="montoResuelto">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Monto resuelto
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="vertical-align: middle">
                                                    <p>{{  element.value | number:'1.0-0'}}</p>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>{{ selectedTotalApprovedAmount | number:'1.0-0' }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="camposColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: camposColumns"></tr>
                                            <tr mat-footer-row *matFooterRowDef="camposColumns"></tr>
                                        </table>
                                    </div>

                                    <div *ngIf="selectedApprovalFlowItem && selectedApprovalFlowItem.valores.otros.length > 0" class="mb-3">
                                        <h3 class="mb-3">Otros campos</h3>

                                        <mat-list>
                                            <ng-container *ngFor="let other of selectedApprovalFlowItem.valores.otros;  let isFirst = first">
                                                <mat-divider *ngIf="isFirst"></mat-divider>
                                                <mat-list-item>
                                                    <span class="font-weight-500">{{ other.nombre }}:</span> {{ other.valor }}
                                                </mat-list-item>
                                                <mat-divider></mat-divider>
                                            </ng-container>
                                        </mat-list>
                                    </div>

                                    <h3 class="mb-3">Comentarios</h3>

                                    <p>{{ selectedApprovalFlowItem?.valores?.comentarios }}</p>
                                </div>

                            </div>
                        </mat-card-content>
                    </mat-card>
                
                </div>
            </mat-step>
        </mat-stepper>
    </div>

</div>